import React from 'react';
import { Label } from 'fw/components';
import { Col, Modal, FormGroup, Row, Button, Glyphicon } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { Switch } from 'fw/forms';
import * as API from 'modules/app/API';
import * as Notifications from 'fw/globals/Notifications';
import Loading from 'layouts/public/loading/Loading'

class ManageNotificationsPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            visible: props.visible,
            dirty: false,
            busy: false,
            disabledSave: true,
            subscribedVob: props.subscribedVob,
            subscribedMajorityOwner: props.subscribedMajorityOwner,
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            visible: nextProps.visible,
            subscribedVob: nextProps.subscribedVob,
            subscribedMajorityOwner: nextProps.subscribedMajorityOwner,
        });
    }

    close = (success) => {
        this.setState({
            visible: false,
        }, function () {
            this.props.onClose(success);
        });
    }

    renderIndicator = () => {
        if (this.state.dirty)
            return <Glyphicon glyph="pencil" className="pull-right" style={{ color: "red" }} />
        else
            return null;
    }

    dirt = () => {
        this.setState({
            dirty: true
        });
    }

    setBusy = () => {
        this.setState({
            busy: true
        });
    }

    onSubscribedVobChange = (value) => {
        this.setState({
            disabledSave: false,
            subscribedVob: value
        });
        this.dirt()
    };

    onSubscribedMajorityOwnerChange = (value) => {
        this.setState({
            disabledSave: false,
            subscribedMajorityOwner: value
        });
        this.dirt()
    };

    handleSave = () => {
        const rqChange = {
            subscribedVob: this.state.subscribedVob,
            subscribedMajorityOwner: this.state.subscribedVob ? this.state.subscribedMajorityOwner : this.props.subscribedMajorityOwner,
            certificationId: this.props.certificationId
        };

        // Spinner
        this.setBusy();

        API.Admin.post('/certification/changeVobSubscription', rqChange,
            {
                success: (sr) => {
                    Notifications.success(sr.message);
                    this.setState({
                        busy: false,
                        dirty: false
                    });
                    this.close(true);
                },
                error: (sr) => {
                    Notifications.error(sr.error.errorMessage);
                }
            });
    }

    render() {
        let me = this;
        return (
            <Modal show={this.state.visible} onHide={this.close}
                dialogClassName="modal-30w">
                <Modal.Header>
                    <h3 style={{ marginTop: "10px", marginBottom: "0px" }}>
                        Manage Notifications
                    </h3>
                </Modal.Header>
                <Modal.Body>
                    <React.Fragment>
                        {this.state.busy ?
                            <Loading />
                            :
                            <Row>
                                <Col md={12}>
                                    {this.props.subscribedVob == null || this.props.subscribedMajorityOwner == null || this.props.certificationId == null ?
                                        <React.Fragment>
                                            <Row>
                                                <Col md={12}>
                                                    <h5><em>This action cannot be performed</em></h5>
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                        :
                                        <React.Fragment>
                                            <Row>
                                                <Col md={12}>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col md={12}>
                                                                <Label htmlFor="subscribedVob">Receive VOCS email notifications for the company?</Label>
                                                                <Switch 
                                                                    labelLeft="No" 
                                                                    labelRight="Yes" 
                                                                    bsStyle="success" 
                                                                    managed={true}
                                                                    value={this.state.subscribedVob}
                                                                    onFieldChange={e => me.onSubscribedVobChange(e)}/>
                                                                { !this.state.subscribedVob &&
                                                                    <div className="alert" style={{ textAlign: "center", color: "#721c24", backgroundColor: "#f8d7da", borderColor: "#f5c6cb" }}>
                                                                        <strong>
                                                                            <FontAwesomeIcon icon={faExclamationTriangle} size="1x" />
                                                                            &nbsp;&nbsp;Attention! All associated users and Majority Owner will not receive VOCS notifications.
                                                                        </strong>
                                                                    </div>
                                                                }
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    { this.state.subscribedVob ?
                                                        <FormGroup>
                                                            <Row>
                                                                <Col md={12}>
                                                                    <Label htmlFor="subscribedMajorityOwner">Majority Owner want to receive VOCS notifications for the company?</Label>
                                                                    <Switch 
                                                                        labelLeft="No" 
                                                                        labelRight="Yes" 
                                                                        bsStyle="success" 
                                                                        managed={true}
                                                                        value={this.state.subscribedMajorityOwner}
                                                                        onFieldChange={e => me.onSubscribedMajorityOwnerChange(e)}/>
                                                                    { !this.state.subscribedMajorityOwner &&
                                                                        <div className="alert" style={{ textAlign: "center", color: "#721c24", backgroundColor: "#f8d7da", borderColor: "#f5c6cb" }}>
                                                                            <strong>
                                                                                <FontAwesomeIcon icon={faExclamationTriangle} size="1x" />
                                                                                &nbsp;&nbsp;Attention! Majority Owner will not receive VOCS notifications.
                                                                            </strong>
                                                                        </div>
                                                                    }
                                                                </Col>
                                                            </Row>
                                                        </FormGroup>
                                                    :null}
                                                </Col>
                                                
                                            </Row>
                                            <Row>
                                                <Col md={12}>
                                                    <br />
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                    }
                                </Col>
                            </Row>
                        }
                    </React.Fragment>
                </Modal.Body>
                <Modal.Footer>
                    <Button id="btnSaveChanges" bsStyle="success"
                        disabled={!this.state.dirty || this.state.busy || this.state.disabledSave} onClick={this.handleSave}>Save Changes</Button>
                    <Button onClick={this.close} disabled={this.state.busy}>Close</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default ManageNotificationsPopUp;


// WEBPACK FOOTER //
// ./src/areas/admin/connectToVOB/ManageNotificationsPopUp.js